import { apiAsync } from '../../common/helpers'

export const fetchSummaries = async (props) => {
  const apiEndpoint = `external/companies/${props.companyId}/summaries`
  const params = {
    product: props.product,
    sort: props.sort,
    sortOrder: props.sortOrder,
    page: props.pageNumber,
    pageSize: props.pageSize,
    searchText: props.searchText,
    stateCodeFilter: props.stateCodeFilter
  }
  return apiAsync({
    method: 'GET',
    api: apiEndpoint,
    params
  })
}

export const fetchCsvFile = async (props) => {
  const apiEndpoint = `external/companies/${props.companyId}/locations/export`
  const params = {
    output: props.output,
    product: props.product,
    stateCodeFilter: props.stateCodeFilter,
    sortDirection: props.sortDirection,
    sortField: props.sortField,
    searchText: props.searchText
  }
  return apiAsync({
    method: 'GET',
    api: apiEndpoint,
    params
  })
}
